import React from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';

function EmbedWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const content_src = useSelector(state => state.dashboard.widgets[widgetId].settings?.content_src);
    const content_url = useSelector(state => state.dashboard.widgets[widgetId].settings?.content_url);
    const content_html = useSelector(state => state.dashboard.widgets[widgetId].settings?.content_html);
    const parameters = useSelector(state => state.dashboard.widgets[widgetId].settings?.parameters);

    return (
        <fieldset>
            <label style={{ width: '100%' }} htmlFor="content_src">
            {I18n.t('content_src')}
            </label>
            <div onChange={e => (setAttribute('settings.content_src', e.target.value))}>
                <input type="radio" value="Url" defaultChecked={content_src == 'Url'} name="content_src"/> {I18n.t('url')}
                <br/>
                <input type="radio" value="HTML" defaultChecked={content_src == 'HTML'} name="content_src"/> {I18n.t('html')}
            </div>
            <label style={{ width: '100%' }} htmlFor="content_url">
            {I18n.t('content_url')}
            </label>
            <input 
                type="text" 
                className="form-control"
                name="content_url" 
                value={content_url} 
                onChange={e => (setAttribute('settings.content_url', e.target.value))} 
            />
            <label style={{ width: '100%' }} htmlFor="content_html">
            {I18n.t('content_html')}
            </label>
            <input 
                type="text" 
                className="form-control"
                name="content_html" 
                value={content_html} 
                onChange={e => (setAttribute('settings.content_html', e.target.value))} 
            />
            <label style={{ width: '100%' }} htmlFor="parameters">
            {I18n.t('parameters')}
            </label>
            <input 
                type="text" 
                className="form-control"
                name="parameters" 
                value={parameters} 
                onChange={e => (setAttribute('settings.parameters', e.target.value))} 
            />
        </fieldset>
    )
}

export default EmbedWidgetSettings;
